module.exports = __webpack_public_path__ + "static/img/role-mr-type-110e9d9d.e14856e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role-mr-type-110e9d9d.png
// module id = TA1k
// module chunks = 1